import axios from "axios";
import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class AnnouncementService {
  getAnnouncements(params) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "admin/announcement/list", params);
  }

  getAnnouncementDetails(id) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `admin/announcement/details/${id}`);
  }

  createAnnouncement(body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "admin/announcement/create", body);
  }

  updateAnnouncement(body) {
    return httpRequestAdmin.put(process.env.REACT_APP_BACKEND_API_URL + "admin/announcement/update", body);
  }

  deleteAnnouncement(id) {
    return httpRequestAdmin.delete(process.env.REACT_APP_BACKEND_API_URL + `admin/announcement/delete/${id}`);
  }

  getAnnouncementStats(id) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `admin/announcement/stats/${id}`);
  }

  resetRecipients(id) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + `admin/announcement/reset-recipients/${id}`);
  }

  generatePresignedUrl(params) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "admin/generate-presigned-url", params);
  }

  async uploadMedia(file, onProgress) {
    const res = await this.generatePresignedUrl({
      fileName: file.name,
      fileType: file.type || "application/octet-stream",
    });

    const data = res?.data || res;
    const uploadUrl = data?.uploadUrl;
    const fileUrl = data?.fileUrl || data?.url || uploadUrl?.split("?")[0];

    if (!uploadUrl) {
      throw new Error("Failed to get presigned upload URL");
    }

    await axios.put(uploadUrl, file, {
      headers: {
        "Content-Type": file.type || "application/octet-stream",
        "x-amz-acl": "public-read",
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total && onProgress) {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(progress);
        }
      },
    });

    return fileUrl;
  }
}

export default new AnnouncementService();
